export { default } from './container'



// WEBPACK FOOTER //
// ./src/pages/widgets/form/configure-filtering/index.js